import { createHttpHeaderWithAuthorization } from "../../services/http-header";
import { callWithRetry } from "../../services/callWithRetry";
import {
  APP_PDC_URL,
  B2BREAD_API_URL_V2
} from "../../../config";

export const previewConstants = {
  OPEN_PREVIEW_NEW_START: "OPEN_PREVIEW_NEW_START",
  OPEN_PREVIEW_NEW_SUCCESS: "OPEN_PREVIEW_NEW_SUCCESS",
  OPEN_PREVIEW_NEW_ERROR: "OPEN_PREVIEW_NEW_ERROR",
  OPEN_PREVIEW_NEW_CLEAR: "OPEN_PREVIEW_NEW_CLEAR"
};

export function clearContent() {
  return function(dispatch) {
    dispatch({
      type: previewConstants.OPEN_PREVIEW_NEW_CLEAR
    });
  };
}

/**
 * andando sulle b2bRead restituisce l'html/xml della fattura richiesta
 */
export function openEinvoicePreview(documentId, typePreview) {

  return (dispatch, getState) => {
    const auth = getState().auth;

    let customHeader = createHttpHeaderWithAuthorization(auth.loginAuth.securityToken);
    /* customHeader["Accept"] = "application/hal+json";
    customHeader["Content-Type"] = "application/hal+json";*/

    switch (typePreview){
    case "ASSOSW": 
      customHeader["Accept"] = "text/html";
      break;
    case "XML":
    case "RAW":
      customHeader["Accept"] = "application/xml";
      break;
    case "ADE":
      customHeader["Accept"] = "text/html";
      break;
    default:
      break;
    }    

    let request = {
      method: "GET",
      url: `${B2BREAD_API_URL_V2}/${documentId}/preview?type=${typePreview}`,
      headers: customHeader
    };

    return new Promise(function(resolve, reject) {
      dispatch({
        type: previewConstants.OPEN_PREVIEW_NEW_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(result => {
          dispatch({
            type: previewConstants.OPEN_PREVIEW_NEW_SUCCESS,
            payload: result.data
          });
          resolve(result.data);
        })
        .catch(response => {
          dispatch({
            type: previewConstants.OPEN_PREVIEW_NEW_ERROR,
            payload: response.message ? response.message : response
          });
          reject(response);
        });
    });
  };
}

export function openPreviewNew(
  documentId,
  pageNumber,
  isFepa
) {

  return (dispatch, getState) => {
    const auth = getState().auth;
    const typeAccount = getState().main.myType;
    const clientIdSelected = getState().main.clientIdSelected;
    const accountantIdSelected = getState().main.accountantIdSelected;

    let request;
    let url = isFepa
      ? APP_PDC_URL + "/fepa/render"
      : APP_PDC_URL +
      "/v2/documents/" +
      documentId +
      "/preview/" +
      pageNumber +
      "?itemId=" +
      clientIdSelected +
      "&accountantId=" +
      accountantIdSelected;

    if (isFepa && typeAccount === "STUDIO") {
      url = url + "?onlyReceived=true";
    }

    if (isFepa) {
      request = {
        method: "post",
        url: url,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
        data: {
          outputFormat: "image/jpeg",
          documentId: documentId,
          itemId: clientIdSelected,
          accountantId: accountantIdSelected
        }
      };
    } else {
      request = {
        method: "get",
        url: url,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
      };
    }

    return new Promise(function(resolve, reject) {
      dispatch({
        type: previewConstants.OPEN_PREVIEW_NEW_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(result => {
          let content = isFepa
            ? result.data.encodedContent
            : result.data.content;
          // mixpanel.track("Anteprima WEB ");
          dispatch({
            type: previewConstants.OPEN_PREVIEW_NEW_SUCCESS,
            payload: content
          });
          resolve(result.data);
          // todo: capire come  segnare come letto il documento
        })
        .catch(response => {
          dispatch({
            type: previewConstants.OPEN_PREVIEW_NEW_ERROR,
            payload: response.message ? response.message : response
          });
          reject(response);
        });
    });
  };
}
